export const PLACEMENT_DETAILS_BASEURL = '/placementDetails';
export const ASSOCIATE_PROFILE_BASEURL = '/associateProfile';
export const PLACEMENT_OVERVIEW_BASEURL = '/placementsOverview';
